import { apiCall } from "./ApiCallBase";
import { API_CONFIG } from "../shared/constants"

export interface YearListResponse {
    years: [];
}

export interface MakeListResponse {
    makes: [];
}

export interface ModelListResponse {
    models: [];
}


export async function getYears(){
    const url = `${API_CONFIG.BASE_URL}/vehicle/year`
    const headers = {
        "Authorization": `${API_CONFIG.AUTH}`,
        "Content-Type": "application/json",
    };

    return await apiCall<YearListResponse>(url, headers);
}

export async function getMakes(yearId: number){
    const url = `${API_CONFIG.BASE_URL}/vehicle/make?yearId=${yearId}`
    const headers = {
        "Authorization": `${API_CONFIG.AUTH}`,
        "Content-Type": "application/json",
    };

    return await apiCall<MakeListResponse>(url, headers);
}


export async function getModels(yearId: number, makeId: number){
    const url = `${API_CONFIG.BASE_URL}/vehicle/model?yearId=${yearId}&makeId=${makeId}`
    const headers = {
        "Authorization": `${API_CONFIG.AUTH}`,
        "Content-Type": "application/json",
    };

    return await apiCall<ModelListResponse>(url, headers);
}


